module.exports = __webpack_public_path__ + "img/imagenb.8ca8ff4d.png";